
import Hero from './Hero';
import Contact from './ContactUs';
import Environment from './Environment';
import FeaturedPlant from './FeaturedPlant';
import Testimonial from './Testimonial';
import AboutUs from './AboutUs';
import React from 'react';



const Home = () => {
    return (
        <div>
            <Hero />
            <Environment />
            <FeaturedPlant />
            <AboutUs />
            <Testimonial />
            <Contact />
        </div>
    );
};

export default Home;